import React, { useState } from 'react';
import styled from 'styled-components';
import {slide as Menu} from 'react-burger-menu';
import { Link } from 'react-router-dom';

const StyledBurger = styled.div`
    
    display: none;
    

    @media (max-width: 980px) {
        display: block;
    }
    .page-wrap{
        overflow: auto;
    }
        /* Individual item */
    .bm-item {
        display: inline-block;

        /* Our sidebar item styling */
        text-decoration: none;
        margin-bottom: 10px;
        color: #d1d1d1;
        transition: color 0.2s;
    }

    /* Change color on hover */
    .bm-item:hover {
        color: white;
    }

    /* The rest copied directly from react-burger-menu docs */

    /* Position and sizing of burger button */
    .bm-burger-button {
        position: relative;
        width: 26px;
        height: 20px;
       
        top: 36px;
    }

    /* Color/shape of burger icon bars */
    .bm-burger-bars {
        background: #373a47;
    }

    .bm-cross-button {
        height: 36px;
        width: 30px;
    }

    /* Color/shape of close button cross */
    .bm-cross {
    background: #bdc3c7;
    }

    /* General sidebar styles */
    .bm-menu {
    background: #095EB2;
    padding: 2.5em 1.5em 0;
    font-size: 1.15em;
    }

    /* Morph shape necessary with bubble or elastic */
    .bm-morph-shape {
    fill: #373a47;
    }

    /* Wrapper for item list */
    .bm-item-list {
    color: #b8b7ad;
    }

    /* Styling of overlay */
    .bm-overlay {
    background: rgba(0, 0, 0, 0.3);
    }
`;

const Burger = (props) =>{
    const [open, setOpen] = useState(false)

    return (
        <>
            <StyledBurger>
            <Menu right>
                <Link to='/' className="menu-item">Início</Link>
                <Link to={
                                {
                                    pathname:'/homologacao',
                                    state: {
                                        value: 0
                                    }
                                }
                            } className="menu-item">Homologação</Link>
                <Link to={
                                {
                                    pathname:'/reconhecimento',
                                    state: {
                                        value: 4
                                    }
                                }
                            } className="menu-item">Reconhecimento</Link>
                <Link to='/contacto' className="menu-item">Contactos</Link>
            </Menu>
            
            </StyledBurger>
            
        </>
    )
}

export default Burger;